import { Flex } from '@mantine/core';
import { AdvancedSwitch } from '@dealstack/frontend/shared/components/Switch/AdvancedSwitch';
import { ExtendedColumn } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

interface Props<TData, TValue> {
	column: ExtendedColumn<TData, TValue>;
}

// 3-state Yes / No / All toggle for a column whose filter value is the string 'true' | 'false' |
// undefined. Cycles All (undefined) -> Yes ('true') -> No ('false') -> All. Labels are localised.
export const BooleanToggleFilter = <TData, TValue>({ column }: Props<TData, TValue>) => {
	const tCommonUi = useTranslationCommonUi();

	const value = column.getFilterValue() as string | undefined;
	const selectedValue = value === undefined ? value : value === 'true';

	const handleChange = () => {
		if (selectedValue === undefined) {
			column.setFilterValue('true');
		} else if (selectedValue) {
			column.setFilterValue('false');
		} else {
			column.setFilterValue(undefined);
		}
	};

	return (
		<Flex h="100%">
			<AdvancedSwitch
				twoWay={true}
				leftText={tCommonUi('boolean.false')}
				rightText={tCommonUi('boolean.true')}
				leftValue={false}
				rightValue={true}
				selectedValue={selectedValue}
				onChange={handleChange}
			/>
		</Flex>
	);
};
